<template>
    <div v-if="!loadingPage">
      <div class="wui-container user-detail" v-if="info.status !== -1">
        <Swiper :imgs="info.album" :height=400></Swiper>

        <!-- 基本信息 -->
        <div class="user" v-if="info.id">
          <div class="user-base">
            <div class="name">{{info.name}}</div>
            <div class="property">
              <div class="other" v-if="Number(info.gender) || info.age || info.from_country">
                <span v-if="info.gender == 1" class="iconfont icon-man"></span>
                <span v-if="info.gender == 2" class="iconfont icon-woman1"></span>
                <span class="dot" v-if="info.age !== 0 && info.gender > 0">·</span>
                <span class="age" v-if="info.age">{{info.age}}</span>
                <span class="dot" v-if="info.from_country">·</span>
                <span class="from">{{info.from_country}}</span>
              </div>
              <div class="occupation" v-if="info.occupation">
                <span class="iconfont icon-office"></span>
                <span class="txt">{{info.occupation}}</span>
              </div>
            </div>
            <div class="language">
              <span>{{util.join(info.language, ' · ')}}</span>
            </div>
          </div>

          <!-- 标签 -->
          <div
              class="tags"
              v-if="info.tags.length > 0 || info.motion.length > 0 || info.cate.length > 0 || info.reading.length > 0 || info.footprint.length > 0"
          >
            <div class="tags-section" v-if="info.tags && info.tags.length > 0">
              <span class="iconfont icon-smile"></span>
              <div class="tag-list">
                <div class="tag-item" v-for="item in info.tags" :key="item.id">{{item.name}}</div>
              </div>
            </div>

            <div class="tags-section" v-if="info.motion && info.motion.length > 0">
              <span class="iconfont icon-Spot"></span>
              <div class="tag-list">
                <div
                    class="tag-item"
                    v-for="item in info.motion"
                    :key="item.id"
                >{{item.name}}</div>
              </div>
            </div>

            <div class="tags-section" v-if="info.cate && info.cate.length > 0">
              <span class="iconfont icon-food"></span>
              <div class="tag-list">
                <div class="tag-item" v-for="item in info.cate" :key="item.id">{{item.name}}</div>
              </div>
            </div>

            <div class="tags-section" v-if="info.reading && info.reading.length > 0">
              <span class="iconfont icon-Book"></span>
              <div class="tag-list">
                <div
                    class="tag-item"
                    v-for="item in info.reading"
                    :key="item.id"
                >{{item.name}}</div>
              </div>
            </div>

            <div class="tags-section" v-if="info.footprint && info.footprint.length > 0">
              <span class="iconfont icon-City1"></span>
              <div class="tag-list">
                <div
                    class="tag-item"
                    v-for="item in info.footprint"
                    :key="item.id"
                >{{item.name}}</div>
              </div>
            </div>
          </div>

          <!-- 与TA分享 -->
          <div class="share" v-if="info.share && info.share.length > 0">
            <div class="share-title">
              <img src="@/assets/img/Share.svg" />
            </div>
            <div class="tag-list">
              <div class="tag-item" v-for="item in info.share" :key="item.id">{{item.name}}</div>
            </div>
          </div>

          <div class="introduce" v-if="info.introduce" v-html="info.introduce"></div>
        </div>

        <!-- TA的房源 -->
        <div class="personal-section" v-if="houseList && houseList.length > 0">
          <div class="section-header">
            <div class="title">{{$t('TA的房源')}}</div>
          </div>
          <div class="house-list">
            <router-link
                :to="`/rent-apartment/${item.id}`"
                class="house-item"
                v-for="item in houseList"
                :key="item.id"
            >
              <div class="house-imgs">
                <div class="house-img" v-for="(img, index) in item.imgs" :key="img">
                  <img :src="util.thumb(img, 345, 240)" />
                  <span v-if="index == 0 && item.video" class="iconfont icon-Play"></span>
                </div>
              </div>
              <div class="house-info">
                <span class="house-price">{{item.rent}}</span>
                <div class="house-tag" v-for="item in item.tags" :key="item">{{item}}</div>
              </div>
              <div class="house-address">{{item.address}}</div>
            </router-link>
          </div>
        </div>
        <!-- TA的 社区动态 -->
        <div class="personal-section lifestyle-section" v-if="leftList.length || rightList?.length">
          <div class="section-header">
            <div class="title">{{$t('TA的动态')}}</div>
          </div>
          <van-list
              v-model:loading="loading"
              :finished="finished"
              :loading-text="$t('加载中')"
              @load="onLoad"
          >
            <div class="lifestyle-list">
              <div class="list-col left">
                <CommunityItem v-for="item in leftList" :key="item.id" :info="item"></CommunityItem>
              </div>
              <div class="list-col right">
                <CommunityItem v-for="item in rightList" :key="item.id" :info="item"></CommunityItem>
              </div>
            </div>
          </van-list>
        </div>

        <!-- <div class="btn-message" @click="$downloadApp"> -->
        <div class="btn-message" @click="$downloadApp('userDetail', {userId: info.id})">
          <span class="iconfont icon-Chat"></span>
          <span>{{$t('私信')}}</span>
        </div>

        <HomeButton position="left"></HomeButton>

      </div>
      <Empty v-else/>
    </div>
</template>

<script>
import { useRoute } from "vue-router";
import { List } from 'vant';

import api from "@/api/index";
import Swiper from "@/components/Swiper.vue";
import CommunityItem from "@/components/CommunityItem.vue";
import HomeButton from "@/components/HomeButton.vue";
import { initWechatJSSDK } from "@/assets/wechat.js"
import Empty from "@/components/Empty.vue";

export default {
    components: {
        Empty,
        VanList: List,
        Swiper,
        CommunityItem,
        HomeButton
    },
    data() {
        return {
            id: "",
            info: {},
            houseList: [],
            usedList: [],
            subjectList: [],
            pn: 0,
            ps: 20,
            loading: false,
            loadingPage:false,
            finished: false,
            leftHeight: 0,
            rightHeight: 0,
            leftList: [],
            rightList: []
        };
    },
    mounted() {
        const route = useRoute();
        this.id = route.params.id;
        this.onRefresh();
        this.getUserInfo();
        this.getUserInfoByPHP();
    },
    methods: {
        // 加载
        onLoad(){
            if (this.finished) {
                return false;
            }
            this.pn++;
            this.getCommunityList();
        },
        // 刷新
        onRefresh(){
            this.pn = 1;
            this.loading = true;
            this.finished = false;
            this.leftHeight = 0;
            this.rightHeight = 0;
            this.leftList = [];
            this.rightList = [];
            this.getCommunityList();
        },
        // 获取Lifestyle列表
      getCommunityList() {
            let params = {
                userId: this.id,
                page: this.pn,
                count: this.ps,
            };
            api.community.getCommunityByUser(params).then(res => {
                let data = res.data?.list || [];

                let leftHeight = this.leftHeight;
                let rightHeight = this.rightHeight;
                let leftList = this.leftList;
                let rightList = this.rightList;
                data.forEach(item => {
                    if (item.shape === 'rect') {
                      item.rectangle = true;
                    }
                    if (rightHeight >= leftHeight) {
                        leftList.push(item);
                        if (item.rectangle) {
                            leftHeight += 1.5;
                        } else {
                            leftHeight += 1;
                        }
                    } else {
                        rightList.push(item);
                        if (item.rectangle) {
                            rightHeight += 1.5;
                        } else {
                            rightHeight += 1;
                        }
                    }
                });
                if (data.length < this.ps) {
                    this.finished = true;
                }

                this.leftHeight = leftHeight;
                this.rightHeight = rightHeight;
                this.leftList = leftList;
                this.rightList = rightList;
                this.loading = false;
            });
        },
        getUserInfo() {
          this.loadingPage = true;
            api.user.getInfo({ id: this.id }).then(res => {
                res.data.album.unshift(res.data.avatar);

                this.info = res.data;
                if(res.data.status === -1){
                  document.title = "内容已关闭"
                }else{
                  document.title = `${this.info.name}：${this.info.occupation}，来自：${this.info.from_country}`;
                }
                initWechatJSSDK({
                    title: res.data.name,
                    desc: res.data.introduce,
                    imgUrl: res.data.avatar
                });
            }).finally(()=>{
              this.loadingPage = false;
            })
        },
        getUserInfoByPHP() {
            api.user.getUserInfo({ userId: this.id }).then(res => {
                res.data.houseList.forEach((item)=>{
                    item.imgs = item.imgs.splice(0, 3);
                    if (item.dailyRent) {
                        item.tags.push(item.dailyRent);
                    }
                })
                this.houseList = res.data.houseList;
                this.usedList = res.data.usedList;
                this.subjectList = res.data.subjectList;
            });
        }
    },
    setup() {}
};
</script>

<style scoped>
.user-detail{
    padding-bottom: 70px;
}
.user {
    position: relative;
    padding: 15px;
    margin-top: -15px;
    border-radius: 15px;
    background-color: #ffffff;
}
.user .user-base {
    padding-bottom: 13px;
    border-bottom: 2px dashed rgba(248, 248, 248, 1);
}
.user .user-base .name {
    font-weight: 600;
    font-size: 26px;
    line-height: 36px;
    color: #111111;
}
.user .user-base .property {
    display: flex;
    padding: 6px 0 10px 0;
}
.user .property .other {
    display: inline-flex;
    align-items: center;
    height: 23px;
    padding: 0 5px;
    background: rgba(17, 17, 17, 0.03);
    border-radius: 6px;

    font-size: 12px;
    color: #111111;
}
.user .property .other .dot {
    padding: 0 4px;
}
.user .property .other .iconfont {
    font-size: 14px;
    line-height: 1;
    padding-left: 2px;
}
.user .occupation {
    display: flex;
    align-items: center;
    height: 23px;
    padding: 0 5px;
    background: rgba(17, 17, 17, 0.03);
    border-radius: 6px;
    margin-left: 10px;
}
.user .occupation .txt {
    font-size: 12px;
    color: #111111;
}
.user .occupation .iconfont {
    padding: 0 2px;
}
.user .user-base .language {
    font-size: 14px;
    line-height: 20px;
    color: #111111;
}

.user .tags {
    padding: 13px 0 8px 0;
}
.user .tags-section {
    display: flex;
    align-items: flex-start;
}
.user .tags-section .iconfont {
    width: 32px;
    font-size: 22px;
    height: 24px;
    display: flex;
    align-items: center;
    margin: 7px 0;
}
.user .tag-list {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
}
.user .tag-item {
    display: flex;
    align-items: center;
    padding: 0 7px;
    height: 24px;
    background: rgba(17, 17, 17, 0.03);
    margin-right: 10px;
    margin-top: 7px;
    margin-bottom: 7px;
    border-radius: 6px;
    font-size: 13px;
    color: #111111;
}
.user .share {
    padding: 10px 12px 0 12px;
    background: rgba(248, 248, 248, 0.4);
    border-radius: 15px;
}
.user .share .share-title {
    display: flex;
}
.user .share .share-title image {
    width: 54px;
    height: 24px;
}
.user .share .tag-list {
    padding: 3px 0 3px 0;
}
.user .introduce {
    padding: 0 5px;
    margin-top: 13px;
    font-size: 14px;
    line-height: 24px;
    color: #111111;
}

.personal-section {
    padding: 20px 15px;
    background-color: #ffffff;
    margin-top: 10px;
    border-radius: 15px;
}
.personal-section .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 12px;
}
.personal-section .section-header .title {
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    color: #111111;
}
.personal-section .section-header .more {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    color: #666666;
}

.house-item {
    display: block;
    margin-bottom: 15px;
}
.house-item:last-child {
    margin-bottom: 0;
}
.house-item .house-imgs {
    display: flex;
    margin-bottom: 8px;
}
.house-item .house-img {
    position: relative;
    width: 33.33%;
    height: 100px;
    margin-right: 1px;
}
.house-item .house-img .iconfont {
    position: absolute;
    right: 10px;
    bottom: 12px;
    color: #fff;
    font-size: 10px;
}
.house-item .house-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.house-item .house-info {
    display: flex;
    flex-wrap: wrap;
    max-height: 54px;
    overflow: hidden;
}
.house-item .house-info .house-price {
    display: flex;
    align-items: center;
    height: 23px;
    font-size: 14px;
    color: #2db6b4;
    margin-right: 8px;
}
.house-item .house-info .house-tag {
    display: inline-block;
    box-sizing: border-box;
    padding: 0 7px;
    height: 23px;
    line-height: 21px;
    border-radius: 6px;
    border: 1px solid rgba(17, 17, 17, 0.03);
    font-size: 12px;
    color: #666;
    margin-right: 8px;
    margin-bottom: 4px;
}
.house-item .house-address {
    margin-top: 2px;
    font-size: 15px;
    line-height: 21px;
    color: #111111;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.used-list {
    display: flex;
    justify-content: space-between;
}
.used-list .used-item {
    width: 48%;
}
.used-list .used-item .used-img {
    position: relative;
    padding-bottom: 100%;
    background-color: #f8f8f8;
    border-radius: 4px;
}
.used-list .used-item .used-img .cover {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
.used-list .used-item .used-img .collect {
    position: absolute;
    display: flex;
    align-items: center;
    top: 14px;
    right: 10px;
}
.used-list .collect .like {
    width: 20px;
    height: 17px;
}
.used-list .collect text {
    margin-left: 3px;
    font-weight: 500;
    font-size: 12px;
    color: #ffffff;
    text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.35);
}
.used-list .used-item .used-title {
    font-size: 15px;
    line-height: 21px;
    color: #111111;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.used-list .used-item .used-price {
    display: flex;
    align-items: center;
    padding: 14px 0 10px 0;
}
.used-list .used-item .used-price .present {
    font-size: 15px;
    line-height: 21px;
    color: #2db6b4;
}
.used-list .used-item .used-price .original {
    font-size: 14px;
    line-height: 20px;
    color: #999999;
    text-decoration: line-through;
    margin-left: 6px;
}

.lifestyle-list {
    display: flex;
    align-items: flex-start;
}
.lifestyle-section {
    background: linear-gradient(
        186.87deg,
        #ffffff 69.11%,
        rgba(255, 255, 255, 0) 94.61%
    );
}

.lifestyle-list .list-col {
    width: 50%;
    overflow: hidden;
}

.lifestyle-list .left {
    margin-right: 13px;
}

.btn-message {
    position: fixed;
    z-index: 1000;
    padding: 0 20px;
    height: 46px;
    right: 15px;
    bottom: 40px;
    background: #2db6b4;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 16px;
    color: #ffffff;
}
.btn-message .iconfont {
    font-size: 20px;
    margin-right: 8px;
}

.btn-edit {
    position: fixed;
    z-index: 1000;
    padding: 0 20px;
    height: 46px;
    right: 25px;
    bottom: 40px;
    background: #2db6b4;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 16px;
    color: #ffffff;
}

.btn-edit .iconfont {
    font-size: 20px;
    margin-right: 8px;
}
</style>
